import { getSearchSections } from "@pulsex/services";
import { useQuery } from "@tanstack/react-query";
export default function useSearchSections({ config, }) {
    return useQuery({
        queryKey: ["searchSections"],
        queryFn: () => getSearchSections(config),
    });
}
